import {useEffect, useState} from "react";
import {getTokenService} from "./useTokenService";
import axios from "axios";
import {settings} from "../config";

export const useBidRates = ({orderId, user}: { orderId: number, user: any }) => {
    const [state, setState] = useState<any>({bidRates: {}})
    useEffect(() => {
        getRates().then(() => {
        })
    }, [orderId])
    const getRates = async () => {
        let {token} = getTokenService({user: user})
        const {data} = await axios.get(settings.baseUrl + `AdminBidList/GetBidPriceData/${orderId}`, {headers: {"Authorization": "Bearer " + token()}})
        setState({...state, bidRates: data[0]})
        return data
    }
    return {
        bidRates: state.bidRates,
    }
}